export const customCheckboxStyles = `
  .tmce-plugin-custom-checkbox-container {
    margin: 1em 0;
  }

  .tmce-plugin-custom-checkbox-block {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0;
  }

  .tmce-plugin-custom-checkbox {
    display: inline-block;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    border: 2px solid #222f3e;
    border-radius: 3px;
    cursor: pointer !important;
    flex-shrink: 0;
    margin: 0;
    position: relative;
    outline: none !important;
  }

  .tmce-plugin-custom-checkbox-check {
    position: absolute;
    top: -1px;
    left: 3px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    pointer-events: none;
  }
`;
